import { Button, CheckIcon, CloseIcon, IconButton, Modal, Typography } from "@povio/ui";
import Image from "next/image";
import { useRouter } from "next/router";

import WelcomeRewardImage from "@/assets/images/wallet/welcome-reward.png";
import { RouteConfig } from "@/config/route.config";
import { useClaimRewardModalStore } from "@/providers/wallet/wallet.store";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const WelcomeRewardModal = ({ isOpen, onClose }: Props) => {
  const router = useRouter();
  const { setShowClaimRewardModal } = useClaimRewardModalStore();

  const handleClaimReward = () => {
    onClose();
    router.push(RouteConfig.MyWallet);
    setShowClaimRewardModal(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalClassName="p-0!"
    >
      <div className="flex w-full max-w-[480px] flex-col items-center justify-start gap-2">
        <div className="flex w-full flex-row items-baseline justify-between px-5 py-4">
          <Typography
            size="title-3"
            variant="prominent-1"
            className="text-text-default-1"
          >
            Welcome to Lossdog
          </Typography>
          <IconButton
            icon={CloseIcon}
            onPress={onClose}
            label="Close"
            variant="ghost"
            color="secondary"
          />
        </div>
        <Typography
          size="body-4"
          className="self-start px-6 py-2 text-text-default-2"
        >
          Such stats. Much promise. So wow.
        </Typography>
        <div className="px-6">
          <Image
            src={WelcomeRewardImage}
            alt="Welcome Reward"
            width={432}
            height={240}
            className="h-full w-full rounded-sm object-cover"
          />
        </div>
        <Typography
          size="body-4"
          className="max-w-96 self-start px-6 py-2 text-text-default-2"
        >
          Welcome to Lossdog. Thanks for completing your onboarding, Now it's time for your 1st treat.
        </Typography>
        <div className="flex flex-row items-center justify-between gap-4 p-6">
          <Button
            variant="contained"
            color="secondary"
            size="s"
            onPress={handleClaimReward}
            icon={CheckIcon}
            iconPosition="left"
          >
            Claim Reward
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            size="s"
            onPress={onClose}
            icon={CloseIcon}
            iconPosition="left"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};
